import QuillMention from 'quill-mention';
import Quill from "quill";


export interface Config {
  container: string
  unit: 'word' | 'char'
}

const alignClass = Quill.import('attributors/style/align');
const backgroundClass = Quill.import('attributors/style/background');
const colorClass = Quill.import('attributors/style/color');
const directionClass = Quill.import('attributors/style/direction');
const fontClass = Quill.import('attributors/style/font');
const sizeClass = Quill.import('attributors/style/size');

Quill.register(alignClass, true);
Quill.register(backgroundClass, true);
Quill.register(colorClass, true);
Quill.register(directionClass, true);
Quill.register(fontClass, true);
Quill.register(sizeClass, true);
Quill.register({ 'modules/mention': QuillMention }, true);

export default class Counter {
  quill: Quill;
  options: Config

  constructor(quill, options) {
    this.quill = quill
    this.options = options

    const container = document.querySelector(this.options.container)

    this.quill.on('editor-change', () => {
      const length = this.calculate()

      if (container) {
        container.innerHTML = length + ' ' + this.options.unit + 's'
      }
    })
  }

  calculate() {
    const text = this.quill.getText().trim()

    if (this.options.unit === 'word') {
      return text ? text.split(/\s+/).length : 0
    }
    return text.length
  }
}
